import $ from 'jquery';
/**
 * Created by Ewa.Podrazka on 2018-06-18.
 */
export var compareFields = function (value, element) {
    var compareField = $(element).data('compare_field');
    var elementVal = $(element).val();
    if ($(compareField).val() !== '' || elementVal !== '') {
        var expression = element.dataset.regular ? element.dataset.regular : '';
        var maxValue = parseInt(element.dataset.regularMaxValue);
        var regularExpression = new RegExp(expression);
        if (expression) {
            if ($(compareField).val() !== '' && !regularExpression.test(value)) {
                if (parseInt(elementVal) <= maxValue || elementVal === '') {
                    $(element).removeClass('is-invalid');
                    $(element)
                        .closest('.bss-text-input')
                        .find('.bss-error-message')
                        .removeClass('is-invalid');
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                if ($(compareField).val() === '') {
                    $(compareField).removeClass('is-invalid');
                    $(compareField)
                        .closest('.bss-text-input')
                        .find('.bss-error-message')
                        .removeClass('is-invalid');
                }
                return regularExpression.test(value);
            }
        }
        else {
            if ($(compareField).val() === '') {
                $(compareField).removeClass('is-invalid');
                $(compareField)
                    .closest('.bss-text-input')
                    .find('.bss-error-message')
                    .removeClass('is-invalid');
            }
            return true;
        }
    }
    else if ($(compareField).val() === '' && elementVal === '') {
        return false;
    }
    else {
        return true;
    }
};
